export const CATEGORIES = [
  {
    id: "01",
    name: "IT Hardware, Computer & Accessories",
    tagline: "Sales, rental, upgrades & repair for the complete workplace stack.",
    services: [
      "Desktop & Laptop Sales", "New & Refurbished Computer Systems", "Desktop & Laptop Rental",
      "Server & Storage Solutions", "Server Rack Sales & Supply", "Monitors & Displays",
      "Projector Sales & Supply", "Computer Peripherals & Accessories", "Keyboard & Mouse",
      "Webcams", "Speakers & Conference Devices", "Professional Call-Center Headsets",
      "USB & Wired Headsets", "Wireless & Bluetooth Headsets", "Noise-Cancelling Headsets",
      "Call-Center Communication Accessories", "RAM / Memory Upgrade", "SSD Sales & Upgrade",
      "HDD Sales & Upgrade", "Memory Card Sales", "Pen Drive / USB Storage Sales",
      "Motherboard Sales & Replacement", "Processor / CPU Sales & Replacement",
      "SMPS / Power Supply Sales & Replacement", "Computer Parts Sales & Supply",
      "Computer Parts Replacement", "Hardware Installation & Replacement",
      "Hardware Upgrade & Expansion", "System Installation & Configuration",
      "Desktop & Laptop Troubleshooting", "IT Hardware Repair & Support",
      "Remote & On-Site IT Support", "IT Equipment Rental",
    ],
  },
  {
    id: "02",
    name: "Networking & IT Infrastructure",
    tagline: "Enterprise-grade wired, wireless & server infrastructure.",
    services: [
      "LAN/WAN & Enterprise Networking Solutions", "Structured Cabling Solutions",
      "Fiber Optic Networking", "Network Rack & Rack Management", "Router Sales & Supply",
      "Router Configuration", "Switch Sales & Supply", "Managed Switch Sales & Supply",
      "Switch Configuration", "Managed Switch Configuration", "Wireless Access Point Sales & Supply",
      "Access Point Configuration", "VLAN & Network Segmentation", "VPN Setup & Secure Remote Access",
      "Wi-Fi Site Survey & Optimization", "Network Troubleshooting",
      "Network Installation & Configuration", "Server Installation & Management",
      "Windows Server Setup", "Domain Controller Setup", "Active Directory",
      "Group Policy Management", "Server Virtualization", "Hyper-V Solutions",
      "NAS & Storage Solutions", "Network Infrastructure Upgrade", "Network Equipment Replacement",
    ],
  },
  {
    id: "03",
    name: "Firewall, Cyber Security & VAPT",
    tagline: "Offensive-grade testing, hardening & certified reporting.",
    services: [
      "Firewall Installation & Configuration", "Firewall Management & Monitoring",
      "Firewall Sales & Security Solutions", "Antivirus & Security License Solutions",
      "Endpoint Security", "Device Security Management", "Network Security Solutions",
      "VPN & Secure Remote Access", "Cybersecurity Audit", "Security Assessment",
      "Data Protection Solutions", "Security Policy & Configuration Support",
      "Vulnerability Assessment & Penetration Testing (VAPT)", "Network & Infrastructure VAPT",
      "Web Application Security Testing", "API Security Testing",
      "Mobile Application Security Testing", "Vulnerability Identification & Risk Assessment",
      "Security Hardening & Remediation Support", "VAPT Re-Testing / Validation",
      "Detailed VAPT Report", "Executive Security Assessment Report",
      "Vulnerability Evidence / Proof of Concept", "Remediation Recommendations",
      "VAPT Certificate / Assessment Certificate",
    ],
  },
  {
    id: "04",
    name: "Software & Licensing",
    tagline: "Genuine licensing across Microsoft, Autodesk & business software.",
    services: [
      "Microsoft Windows Licensing", "Microsoft Office Licensing", "Windows Server Licensing",
      "Windows Server CAL Licensing", "Microsoft 365 Licensing", "AutoCAD Licensing",
      "Architecture Software", "Engineering Software", "3D Design Software",
      "Graphic Design & Creative Software", "Real Estate Software", "Business Management Software",
      "Tally Software & Licensing", "Accounting Software", "CRM Software",
      "Industry-Specific Software Solutions", "Software Installation",
      "Software Activation & Configuration", "Software Deployment",
      "Software License Management", "Software Upgrade & Support",
    ],
  },
  {
    id: "05",
    name: "Microsoft 365, Google Workspace & Cloud",
    tagline: "Migration, administration & cloud continuity done right.",
    services: [
      "Microsoft 365 Setup", "Microsoft 365 Migration", "Microsoft 365 Administration",
      "Microsoft 365 Business Solutions", "Business Email Setup", "Email Migration",
      "Email Configuration & Troubleshooting", "Google Workspace Licensing",
      "Google Workspace Migration", "Google Workspace Administration", "Cloud Storage Solutions",
      "Cloud Backup Solutions", "Cloud Infrastructure Management", "Domain & DNS Management",
      "SSL Certificate Solutions", "Website Hosting", "Cloud Email Solutions", "Cloud Data Migration",
    ],
  },
  {
    id: "06",
    name: "HRMS & HR Solutions",
    tagline: "End-to-end people operations, attendance to payroll.",
    services: [
      "HR Management Software", "HRMS (Human Resource Management System)",
      "Employee Database Management", "Employee Records Management",
      "Employee Document Management", "Employee Onboarding & Offboarding",
      "Employee Attendance Management", "Leave Management", "Holiday Management",
      "Shift & Roster Management", "Biometric Attendance Integration", "Payroll Management",
      "Salary Management", "Payslip Management", "Expense & Reimbursement Management",
      "Employee Self-Service (ESS)", "Recruitment Management", "Applicant Tracking System (ATS)",
      "Interview & Candidate Management", "Performance Management", "Employee Evaluation",
      "HR Reports & Analytics", "Attendance Reports", "Payroll Reports",
      "Employee Performance Reports", "Management Dashboards", "HRMS Setup & Configuration",
      "HRMS Customization", "HRMS Data Migration", "HRMS Training & Support", "HRMS Integration",
    ],
  },
  {
    id: "07",
    name: "CRM & Business Management",
    tagline: "Sales pipelines, automation & integrations that close deals.",
    services: [
      "Sales CRM Solutions", "Customer Relationship Management", "Lead Management",
      "Customer Database Management", "Follow-Up & Task Management", "Sales Pipeline Management",
      "Opportunity Management", "Quotation & Customer Tracking", "Customer Support Management",
      "Ticketing CRM", "Sales Automation", "Lead Follow-Up Automation",
      "Task & Reminder Automation", "Business Process Automation", "Sales Dashboards",
      "Management Reports", "CRM Customization", "CRM Implementation", "CRM Data Migration",
      "CRM Integration", "API Integration", "Third-Party Software Integration",
      "CRM Training & Support",
    ],
  },
  {
    id: "08",
    name: "Call Center, Dialer & Communication",
    tagline: "Cloud dialers, IVR & omnichannel customer communication.",
    services: [
      "Cloud Dialer Solutions", "Auto Dialer Solutions", "Predictive Dialer Solutions",
      "Outbound Dialer Solutions", "Inbound Call Solutions", "Dialer Setup & Configuration",
      "Call Center Setup", "Contact Center Solutions", "BPO Technology Solutions",
      "IVR Solutions", "SIP & VoIP Solutions", "Call Recording Solutions", "Call Monitoring",
      "Call Tracking", "Call Reports & Analytics", "Agent Management Solutions",
      "Dialer & CRM Integration", "CRM & Call Center Integration", "Lead-to-Call Automation",
      "Call Disposition Management", "Agent Performance Tracking",
      "WhatsApp Business Integration", "WhatsApp CRM Integration",
      "Business Communication Solutions", "Email & Communication Integration",
      "Customer Communication Automation",
    ],
  },
  {
    id: "09",
    name: "CCTV, Surveillance & Access Control",
    tagline: "Eyes and gates — surveillance to biometric entry.",
    services: [
      "CCTV Camera Solutions", "IP Camera Solutions", "Network CCTV Solutions",
      "DVR Installation", "NVR Installation", "CCTV Configuration", "CCTV Remote Monitoring",
      "Mobile CCTV Viewing Setup", "CCTV Networking", "CCTV Maintenance", "CCTV AMC",
      "Biometric Attendance Systems", "Access Control Systems", "Access Card Systems",
      "Access Card Sales & Supply", "Door Access Systems", "Video Door Phone",
      "Intercom Solutions", "Access Control Installation & Configuration",
      "Biometric Device Installation & Configuration",
    ],
  },
  {
    id: "10",
    name: "Printer, Office, UPS, Backup & Data Recovery",
    tagline: "Print, power & data — the office lifelines, protected.",
    services: [
      "Printer Sales", "Printer Service & Repair", "Scanner Sales & Service", "Printer Networking",
      "Printer Configuration", "Printer & Scanner AMC", "Office Equipment Sales & Supply",
      "Office Equipment Setup", "Office IT Support", "UPS Sales & Supply",
      "UPS Installation & Configuration", "UPS Maintenance & Battery Replacement",
      "Data Backup Solutions", "Cloud Backup", "Local Backup Solutions", "Data Recovery",
      "Data Migration", "Disaster Recovery Solutions", "Backup Monitoring", "Backup Management",
      "Business Continuity Solutions", "Storage & NAS Solutions",
    ],
  },
  {
    id: "11",
    name: "IT AMC & Managed Services",
    tagline: "SLA-backed annual contracts & 24/7 managed support.",
    services: [
      "Annual Maintenance Contracts (AMC)", "Complete IT AMC", "Desktop & Laptop AMC",
      "Server AMC", "Network AMC", "CCTV AMC", "Printer AMC", "UPS AMC",
      "IT Infrastructure AMC", "HRMS / CRM Support AMC", "Managed IT Services",
      "Remote IT Support", "On-Site IT Support", "IT Infrastructure Monitoring",
      "Network Monitoring", "Server Monitoring", "IT Asset Management", "IT Helpdesk Support",
      "On-Demand IT Engineer", "IT Staff Outsourcing", "Preventive IT Maintenance",
      "Hardware Replacement Support", "Software Support & Maintenance",
    ],
  },
  {
    id: "12",
    name: "IT Consulting, Procurement, Domain & Digital",
    tagline: "Strategy, sourcing & your digital identity, managed.",
    services: [
      "IT Infrastructure Planning", "IT Infrastructure Audit", "IT Consulting",
      "Technology Consulting", "Office IT Setup", "New Office IT Deployment",
      "Office Relocation IT Support", "IT Procurement", "IT Hardware Procurement",
      "IT Software Procurement", "Vendor Management", "Software License Management",
      "IT Policy & Documentation", "Business Technology Solutions", "IT AMC Consultancy",
      "Domain Purchase & Registration", "Domain Renewal & Management", "DNS Management",
      "SSL Certificate Solutions", "Business Email Solutions", "Website Hosting",
      "Website Maintenance", "Website Support", "Email Migration & Configuration",
      "IT Asset Procurement & Deployment", "IT Infrastructure Upgrade & Expansion",
      "Biometric Solutions",
    ],
  },
];

export const OFFERINGS = [
  "VAPT Audit", "DPDP Compliance Audit", "ISO Certification", "Email Security",
  "Microsoft 365 Licenses", "Cloud Calling with Multilevel IVR",
  "Firewall / AP / Switch Rentals", "Internet Leased Line", "SIP Trunk", "PRI Line",
  "MPLS Connectivity", "SD-WAN", "WhatsApp Marketing Solutions", "SMS Solutions",
  "RCS Messaging Solutions", "Toll-Free Numbers", "Truecaller Verified Listing",
];

export const MARQUEE_ITEMS = [
  "VAPT AUDIT", "DPDP COMPLIANCE AUDIT", "ISO CERTIFICATION SERVICES",
  "ENTERPRISE FIREWALL RENTALS", "SD-WAN & MPLS CONNECTIVITY",
  "MICROSOFT 365 & GOOGLE WORKSPACE", "CLOUD CALLING & MULTILEVEL IVR",
  "CCTV & BIOMETRIC ACCESS CONTROL", "WHATSAPP & RCS MESSAGING",
  "IT AMC & 24/7 MANAGED SUPPORT",
];

export const TOTAL_SERVICES = CATEGORIES.reduce((acc, c) => acc + c.services.length, 0);
